import ControlViewModel from '@/ViewModels/ControlViewModel';
import LinkViewModel from '@/ViewModels/Controls/LinkViewModel';
import DropDownListViewModel from '@/ViewModels/Controls/DropDownListViewModel';
import ComponentManager from '@/Management/ComponentManager';

export default class AssociationSingleDropDownViewModel extends ControlViewModel {

    /**
     * Die wählbaren Optionen
     */
    public dropDownList: DropDownListViewModel;

    /**
     * Das ViewModel für den Link zum Erzeugen eines neuen Objekts
     */
    public linkCreate: LinkViewModel;

    /**
     * Das ViewModel für den Link zum Editieren des assoziierten Objekts
     */
    public linkEdit: LinkViewModel;

    /**
     * Das ViewModel für den Link zum Lösen der Association
     */
    public linkDisconnect: LinkViewModel;

    /**
     * Das ViewModel für den Link zum Löschen des assoziierten Objekts
     */
    public linkDelete: LinkViewModel;

    /**
     * Die Funktion zum Lösen der Association
     */
    public disconnectItem: Function;

    constructor(params: any) {
        super(params);
        this.dropDownList = this.paramOrDefault(params.dropDownList, null);
        this.linkCreate = this.paramOrDefault(params.linkCreate, null);
        this.linkEdit = this.paramOrDefault(params.linkEdit, null);
        this.linkDisconnect = this.paramOrDefault(params.linkDisconnect, null);
        this.linkDelete = this.paramOrDefault(params.linkDelete, null);
        this.disconnectItem = this.handlerOrDefault(params.disconnectItem);
    }
}

ComponentManager.setViewModel('AssociationSingleDropDownViewModel', AssociationSingleDropDownViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');